<template>
  <div class="foot-con">
    <el-row class="links-container">
      <el-col class="product" :offset="2" :span="4" v-if="footerNavi && footerNavi['木门风格']">
        <el-row class="title">
          <el-link :href="styleHref" :underline="false">木门风格</el-link>
        </el-row>
        <el-row class="item" v-for="item in footerNavi['木门风格']" :key="item.name">
          <el-link v-if="item.name !== '木门风格'" :href="item.url" :underline="false">{{item.name}}</el-link>
        </el-row>
      </el-col>
      <el-col class="map" :span="4" v-if="footerNavi && footerNavi['网站地图']">
        <el-row class="title">
          <el-link :href="mapHref" :underline="false">网站地图</el-link>
        </el-row>
        <el-row class="item" v-for="item in footerNavi['网站地图']" :key="item.name">
          <el-link v-if="item.name !== '网站地图'" :href="item.url" :underline="false">{{item.name}}</el-link>
        </el-row>
      </el-col>
      <el-col class="solution" :span="4" v-if="footerNavi && footerNavi['伯艺服务']">
        <el-row class="title">
          <el-link :href="solutionHref" :underline="false">伯艺服务</el-link>
        </el-row>
        <el-row class="item" v-for="item in footerNavi['伯艺服务']" :key="item.name">
          <el-link v-if="item.name !== '伯艺服务'" :href="item.url" :underline="false">{{item.name}}</el-link>
        </el-row>
      </el-col>
      <el-col class="publicity" :span="10">
        <el-image :src="qrCodeUrl" />
        <div class="buttons">
          <div class="item" @mouseenter="onQrCodeChange('wechatPublic')">
            <i class="iconfont icon-weixin" />
            <span>微信公众号</span>
          </div>
          <el-divider style="margin: 0;" />
          <div class="item" @mouseenter="onQrCodeChange('wechatApp')">
            <i class="iconfont icon-xiaochengxu" />
            <span>关注小程序</span>
          </div>
          <el-divider style="margin: 0;" />

          <div class="item" @mouseenter="
              onQrCodeChange('APP')">
            <i class="iconfont icon-app" />
            <span>下载APP</span>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="copyright-container">
      <el-row>
        <el-image style="width: 200px; " src="https://images.jdzapp.com/sysboye_logo_1000.png" />
      </el-row>
      <el-row>北京伯艺创展木业有限公司版权所有 ©地址：北京市通州区梨园镇九棵树西路188号底商21号1层</el-row>
      <el-row>联系电话：400-6810-018传真：010-69586266 邮箱：bycz8888@163.com</el-row>
      <el-row>备案号：京ICP备13003729号-1</el-row>
    </el-row>
    <!-- <div class="content">
      <div class="lab-group">
        <label class="fs24">客服电话</label>
        <label class="fs50 mar-top-40">{{ phone }}</label>
        <label class="col-ccc fs28 mar-top-10">{{ time }}</label>
        <div class="consult mar-top-40">咨询客服</div>
      </div>
      <div class="verticalline"></div>
      <div class="icon-group">
        <img class="gzh-icon" :src="img1.pic" />
        <label class="mar-top-20">{{img1.des}}</label>
      </div>
      <div class="icon-group">
        <img class="xcxm-icon" :src="img2.pic" />
        <label class="mar-top-20">{{img2.des}}</label>
      </div>
    </div>
    <div class="foot-box">
      <span style="font-family:arial;">&copy;</span>2016-2020CERESHOP版权所有，并保留所有权利 粤ICP备D51DD288号
    </div>-->
  </div>
</template>
<script>
export default {
  name: 'v-foot',
  props: {
    platformInformation: Object,
    footerNavi: Object
  },
  data() {
    return {
      styleHref: '',
      mapHref: '',
      solutionHref: '',
      qrCodeUrl: '',
      phone: '400 800 2100',
      time: '9:00-23:00',
      img1: {
        des: '微信公众号',
        pic: 'static/images/gzh.png'
      },
      img2: {
        des: '小程序码',
        pic: 'static/images/xcxm.png'
      }
    }
  },
  methods: {
    onQrCodeChange(val) {
      this.qrCodeUrl = this.platformInformation[val].pic
    }
  },
  watch: {
    footerNavi: {
      handler(nVal, oVal) {
        this.styleHref = nVal['木门风格'].find(
          (item) => (item.name = '木门风格')
        ).url
        this.mapHref = nVal['网站地图'].find(
          (item) => (item.name = '网站地图')
        ).url
        this.solutionHref = nVal['伯艺服务'].find(
          (item) => (item.name = '伯艺服务')
        ).url
      }
    },
    platformInformation: {
      handler(nVal, oVal) {
        this.qrCodeUrl = nVal.wechatPublic.pic
      }
    }
  }
}
</script>
<style scoped lang="scss">
.foot-con {
  height: 626px;
  min-width: 1440px;
  background-color: white;
  .links-container {
    color: white;
    height: 313px;
    background: #333333;
    .el-col {
      height: 100%;
    }
  }
  .copyright-container {
    padding-top: 64px;
    height: 313px;
    line-height: 30px;
    color: #666666;
    text-align: center;
    font-size: 14px;
  }
  .product {
    background: url('../../../static/images/link-product.jpg') no-repeat 60px
      42px;
    padding-top: 42px;
    padding-left: 128px;
    color: #ababab;
    .title {
      line-height: 24px;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 12px;
    }
    .item {
      line-height: 24px;
      font-size: 14px;
      font-weight: bold;
      margin-top: 6px;
    }
  }

  .map {
    background: url('../../../static/images/link-map.jpg') no-repeat 60px 42px;
    background-color: #464346;
    // #464346
    padding-top: 42px;
    padding-left: 128px;
    color: #ababab;
    .title {
      line-height: 24px;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 12px;
    }
    .item {
      line-height: 24px;
      font-size: 14px;
      font-weight: bold;
      margin-top: 6px;
    }
  }
  .solution {
    background: url('../../../static/images/link-solution.jpg') no-repeat 60px
      42px;
    background-color: #464346;
    // #464346
    padding-top: 42px;
    padding-left: 128px;
    color: #ababab;
    .title {
      line-height: 24px;
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 12px;
    }
    .item {
      line-height: 24px;
      font-size: 14px;
      font-weight: bold;
      margin-top: 6px;
    }
  }
  .publicity {
    padding-top: 48px;
    padding-bottom: 48px;
    padding-left: 96px;
    display: flex;
    .el-image {
      height: 100%;
      width: 217px;
      height: 217px;
    }
    .buttons {
      background-color: #444444;
      padding-top: 16px;
      padding-bottom: 16px;
      display: flex;
      color: #565656;
      flex-direction: column;
      :hover {
        color: #debf6c;
        cursor: pointer;
      }
      .item {
        flex-grow: 1;
        display: flex;
        align-items: center;

        i {
          margin-right: 8px;
          margin-left: 12px;
        }
        span {
          margin-right: 12px;
        }
      }
      .el-divider {
        background-color: #565656;
      }
    }
  }
  //   background-color: #333333;
  //   color: #ffffff;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   flex-direction: column;
  //   .content {
  //     display: flex;
  //     // width: 60%;
  //     // justify-content: space-between;
  //     width: 1240px;
  //     justify-content: space-around;
  //     .lab-group {
  //       display: flex;
  //       flex-direction: column;
  //       label {
  //         font-weight: 400;
  //       }
  //       .consult {
  //         width: 164px;
  //         height: 50px;
  //         color: #cccccc;
  //         border: 1px #cccccc solid;
  //         line-height: 50px;
  //         text-align: center;
  //         cursor: pointer;
  //       }
  //     }
  //     .icon-group {
  //       display: flex;
  //       flex-direction: column;
  //       align-items: center;
  //       label {
  //         font-size: 20px;
  //         font-weight: 400;
  //       }
  //     }
  //     .gzh-icon {
  //       height: 196px;
  //       width: 196px;
  //     }
  //     .xcxm-icon {
  //       height: 196px;
  //       width: 196px;
  //     }
  //     .verticalline {
  //       height: 238px;
  //       width: 1px;
  //       background-color: #666666;
  //     }
  //   }
}
.foot-box {
  margin-top: 80px;
}

.el-link {
  color: #565656;
  :hover {
    color: #debf6c;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/v-foot.vue